import { Line, Circle, Text } from "react-konva";
import { api } from "../../../lib/api";

// GM-only: Obstacle trigger zones (line-shaped trip-wires + circular DC-check markers) and their
// DC labels. Extracted verbatim from MapCanvas.jsx (Phase 42 refactor) — no behavior changes.
export function MapObstaclesLayer({ obstacles, activeTool, handleOverlayClick, setObstacleDialog, gameId, upsertObstacleLocal }) {
  return (
    <>
      {(obstacles || []).filter((o) => o.shape === "line").map((o) => (
        <Line
          key={o.id}
          data-testid={`obstacle-line-${o.id}`}
          points={(o.points || []).flatMap((p) => [p.x, p.y])}
          stroke="#D4AF37"
          strokeWidth={3}
          dash={[6, 5]}
          lineCap="round"
          hitStrokeWidth={16}
          onClick={(e) => { if (handleOverlayClick(e)) return; e.cancelBubble = true; setObstacleDialog({ existing: o }); }}
        />
      ))}
      {(obstacles || []).filter((o) => o.shape !== "line").map((o) => (
        <Circle
          key={o.id}
          data-testid={`obstacle-marker-${o.id}`}
          x={o.x}
          y={o.y}
          radius={o.radius || 40}
          stroke="#D4AF37"
          strokeWidth={2}
          dash={[6, 5]}
          fill="#D4AF3722"
          draggable={!activeTool}
          onClick={(e) => {
            if (handleOverlayClick(e)) return;
            e.cancelBubble = true;
            setObstacleDialog({ existing: o });
          }}
          onDragEnd={async (e) => {
            const x = e.target.x();
            const y = e.target.y();
            const { data } = await api.patch(`/games/${gameId}/obstacles/${o.id}`, { x, y });
            upsertObstacleLocal(data);
          }}
        />
      ))}
      {(obstacles || []).map((o) => (
        <Text
          key={`${o.id}-label`}
          x={(o.shape === "line" ? o.points?.[0]?.x : o.x) - 40}
          y={(o.shape === "line" ? o.points?.[0]?.y : o.y) - 6}
          width={80} align="center" text={`DC ${o.dc}`} fontSize={12} fill="#D4AF37" listening={false}
        />
      ))}
    </>
  );
}
